import { palette, shadow, transition } from '../../styles/tokens';
import { BOOKING_STATUSES } from './config';

interface Booking {
  id: string;
  service_name?: string | null;
  client_name?: string | null;
  start_time: string;
  end_time: string;
  status: string;
  source?: string;
  assigned_name?: string | null;
}

interface Props {
  booking: Booking;
  top: number;
  height: number;
  onClick: (booking: Booking) => void;
}

export function AppointmentBlock({ booking, top, height, onClick }: Props) {
  const status = BOOKING_STATUSES[booking.status] ?? BOOKING_STATUSES.confirmed;
  const isWalkIn = booking.source === 'walk_in';
  const compact = height < 52;

  const fmtTime = (t: string) => {
    const [h, m] = t.split(':').map(Number);
    const ampm = h >= 12 ? 'p' : 'a';
    return `${h % 12 || 12}:${String(m).padStart(2, '0')}${ampm}`;
  };

  return (
    <div
      onClick={(e) => { e.stopPropagation(); onClick(booking); }}
      style={{
        position: 'absolute',
        top,
        left: 2,
        right: 2,
        height: height - 2,
        backgroundColor: status.bg,
        borderLeft: `3px solid ${status.fg}`,
        borderRadius: 6,
        padding: compact ? '2px 6px' : '4px 8px',
        cursor: 'pointer',
        overflow: 'hidden',
        transition: `box-shadow ${transition.fast}, transform ${transition.fast}`,
        fontSize: 12,
        lineHeight: 1.3,
        zIndex: 2,
      }}
      onMouseEnter={(e) => { (e.currentTarget as HTMLDivElement).style.boxShadow = shadow.cardHover; (e.currentTarget as HTMLDivElement).style.transform = 'scale(1.01)'; }}
      onMouseLeave={(e) => { (e.currentTarget as HTMLDivElement).style.boxShadow = 'none'; (e.currentTarget as HTMLDivElement).style.transform = 'none'; }}
    >
      {isWalkIn && (
        <span style={{ fontSize: 9, fontWeight: 700, color: palette.amber, background: palette.amberWash, borderRadius: 3, padding: '0 4px', marginBottom: 1, display: 'inline-block' }}>WALK-IN</span>
      )}
      <div style={{ fontWeight: 600, fontSize: 12.5, color: palette.g800, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
        {booking.service_name ?? 'Appointment'}
      </div>
      {!compact && (
        <>
          <div style={{ fontSize: 11.5, color: palette.g600, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {booking.client_name ?? 'Walk-in'}
          </div>
          <div style={{ fontSize: 10.5, color: palette.g500, marginTop: 1 }}>
            {fmtTime(booking.start_time)} – {fmtTime(booking.end_time)}
          </div>
        </>
      )}
    </div>
  );
}
